import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { IFilterPaginationDto, IRestaurantDto } from '../models';

@Injectable({ providedIn: 'root' })
export class RestaurantService extends ApiService {
  public getRestaurantList(
    model: IFilterPaginationDto,
  ): Observable<IRestaurantDto[]> {
    return this.post(`restaurant/list`, model);
  }

  public getRestaurant(id: number): Observable<IRestaurantDto> {
    return this.get(`restaurant/${id}`);
  }

  public getPrivacyPolicy(id: number): Observable<string> {
    return this.get(`common/pp/${id}`);
  }

  public getTermsAndConditions(id: number): Observable<string> {
    return this.get(`common/tc/${id}`);
  }

  public getAccessibility(id: number): Observable<string> {
    return this.get(`common/ac/${id}`);
  }
}
